import { createTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
const defaultTheme = createTheme();
export const navbarTheme = {
    minHeight: 43,
    maxWidth: defaultTheme.breakpoints.values.lg,
    boxShadow: `0 1px 2.5px ${alpha(defaultTheme.palette.grey[700], 0.25)}`,
    drawerWidth: 260,
    indicator: {
        height: 3,
        radius: "3px 3px 0 0",
    },
    typography: {
        fontFamily: '"Montserrat", sans-serif',
        fontWeight: 600,
    },
    MobileNavbar: {
        hoverOpacity: 0.12,
        selectedOpacity: 0.08,
        selectedBorderLeft: "4px solid",
    },
};
//# sourceMappingURL=navbarTheme.js.map